import React from "react";
import i18n from "../../../../i18n/i18n";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {RouteComponentProps, withRouter} from "react-router";
import {Api} from "../../../../helpers/api";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";
import Loader from "../../../../common/components/shared/loader/loader";
import {RouteParamsModel} from "../../../../common/models/routeParams";
import SimpleInfoElement from "../../../../common/components/shared/simpleInfoElement/simpleInfoElement";
import {DateUtils} from "../../../../helpers/dateUtils";
import {
    GeneralDeclarationDataForFileModel,
    GeneralDeclarationDetailsModel
} from "../../../models/generalDeclaration";
import {GeneralDeclarationService} from "../../../services/generalDeclarationService";
import Table from "../../../../common/components/shared/table/table";
import {LoadingType, LoadingTypeFirstLetter} from "../../../models/enums";
import GeneralDeclarationFile from "./pdfFiles/generalDeclarationFile";
import PdfLink from "../../../../common/components/shared/pdfLink/pdfLink";
import ManifestFile from "./pdfFiles/manifestFile";
import {ManifestDataForFileModel, ManifestModel} from "../../../models/manifest";
import {Utils} from "../../../../helpers/utils";
import ReloadButton from "../../../../common/components/shared/reloadButton/reloadButton";
import {ManifestService} from "../../../services/manifestService";
import {ReactComponent as PrintIcon} from "../../../../statics/icons/icon_print.svg";
import {NavLink} from "react-router-dom";
import {routingAddresses} from "../../../../helpers/routing";

interface GeneralDeclarationDetailsState {
    generalDeclarationData?: GeneralDeclarationDetailsModel | null;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    generalDeclarationDataForFile?: GeneralDeclarationDataForFileModel | null;
    responseForGeneralDeclarationFile: AxiosResponse<HttpErrorModel[] | any> | undefined;
    manifestDataForFile?: ManifestDataForFileModel | null;
    responseForManifestFile: AxiosResponse<HttpErrorModel[] | any> | undefined;
    generalDeclarationId: string | null;
    currentPage: number;
}

class GeneralDeclarationDetails extends React.Component <RouteComponentProps, GeneralDeclarationDetailsState> {
    constructor(props: any) {
        super(props);

        this.state = {
            generalDeclarationData: null,
            response: undefined,
            generalDeclarationDataForFile: null,
            responseForGeneralDeclarationFile: undefined,
            manifestDataForFile: null,
            responseForManifestFile: undefined,
            generalDeclarationId: null,
            currentPage: 0
        };
    }

    async componentDidMount() {
        const params = this.props.match.params as RouteParamsModel;
        const response = await GeneralDeclarationService.getGeneralDeclaration(params.id);
        const responseForGeneralDeclarationFile = await GeneralDeclarationService.getGeneralDeclarationDataForFile(params.id);

        this.setState({
            generalDeclarationData: Api.isSuccess(response) ? response?.data : null,
            response,
            responseForGeneralDeclarationFile,
            generalDeclarationDataForFile: Api.isSuccess(responseForGeneralDeclarationFile) ? responseForGeneralDeclarationFile?.data : null,
            generalDeclarationId: params.id,
        });

        this.getManifestDataForFile(this.state.generalDeclarationData);
    }

    public render(): JSX.Element {
        return (
            <div className="general-declaration-details">
                <div className="content general-declaration-content">
                    {this.renderContent()}
                </div>
            </div>
        );
    }

    private renderContent() {
        if (!Api.isSuccess(this.state.response)) {
            return <HttpError
                response={this.state.response}
                cause={i18n.t("documents.generalDeclaration.details.retrievalErrorSuffix")}
            />;
        } else if (this.state.generalDeclarationData) {
            return this.renderDetails();
        } else {
            return (
                <Loader/>
            );
        }
    }

    private renderDetails() {
        return (
            <>
                {this.renderHeader()}
                {this.renderGeneralDataTop()}
                {this.renderGeneralDataBottom()}
                {this.renderManifests()}
            </>
        );
    }

    private renderHeader() {
        return (
            <div className="header" data-testid="header">
                <span>
                    {i18n.t("documents.generalDeclaration.details.header", {number: this.state.generalDeclarationData!.id})}
                </span>
                <div className="actions">
                    <div className="print-buttons">
                        <PdfLink
                            document={<GeneralDeclarationFile generalDeclaration={this.state.generalDeclarationDataForFile}/>}
                            fileName={i18n.t("documents.generalDeclaration.details.files.generalDeclaration.fileName", {number: this.state.generalDeclarationData!.id})}
                            buttonText={i18n.t("documents.generalDeclaration.details.files.generalDeclaration.button")}
                            buttonVariant="contained"
                            responseFile={this.state.responseForGeneralDeclarationFile}
                            endIcon={<PrintIcon className="print-icon"/>}
                        />
                        <PdfLink
                            document={<ManifestFile manifest={this.state.manifestDataForFile}/>}
                            fileName={i18n.t("documents.generalDeclaration.details.files.manifest.fileName", {number: this.state.generalDeclarationData!.id})}
                            buttonText={i18n.t("documents.generalDeclaration.details.files.manifest.button")}
                            buttonVariant="outlined"
                            responseFile={this.state.responseForManifestFile}
                            disabed={this.state.generalDeclarationData?.manifest?.id ? false : true}
                            endIcon={<PrintIcon className="print-icon"/>}
                        />
                    </div>
                    <ReloadButton
                        reloadFunc={this.reload.bind(this)}
                        testId="general-declaration-details-reload-btn"
                    />
                </div>
            </div>
        );
    }

    private renderGeneralDataTop() {
        return (
            <div className="section">
                <div className="section-content">
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.ferryName")}
                        value={this.state.generalDeclarationData!.ferryName}
                        testId="ferry-name"
                    />
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.ferryImoCode")}
                        value={this.state.generalDeclarationData!.ferryImoCode}
                        testId="ferry-imo-code"
                    />
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.shipownerName")}
                        value={this.state.generalDeclarationData!.shipownerName}
                        testId="shipowner-name"

                    />
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.shipownerImoCode")}
                        value={this.state.generalDeclarationData!.shipownerImoCode}
                        testId="shipowner-imo-code"

                    />
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.voyageNo")}
                        value={this.state.generalDeclarationData!.voyageNo}
                        testId="voyage-no"
                    />
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.ssDraft")}
                        value={this.state.generalDeclarationData!.ssDraft}
                        testId="ss-draft"
                        unit="m"
                    />
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.totalWeight")}
                        value={this.state.generalDeclarationData!.totalWeight}
                        testId="total-weight"
                        unit="kg"
                    />
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.arrivalDeparturePort")}
                        value={this.state.generalDeclarationData!.arrivalDeparturePort}
                        testId="arrival-departure-port"
                    />
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.arrivalDepartureTime")}
                        value={Utils.renderTime(this.state.generalDeclarationData!.arrivalDepartureTime)}
                        testId="arrival-departure-time"
                    />
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.originDestinationPort")}
                        value={this.state.generalDeclarationData!.originDestinationPort}
                        testId="origin-destination-port"
                    />
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.wharfDesc")}
                        value={this.state.generalDeclarationData!.wharfDesc}
                        testId="wharf-desc"
                    />
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.passengersNumber")}
                        value={`${this.state.generalDeclarationData!.passengersNumber}`}
                        testId="passengers-number"
                    />
                </div>
            </div>
        );
    }

    private renderGeneralDataBottom() {
        return (
            <div className="section">
                <div className="section-content small-column-gap">
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.briefOfVoyage")}
                        value={`${this.state.generalDeclarationData!.briefOfVoyage}`}
                        type="box"
                        testId="brief-of-voyage"
                        className="big-width"
                    />
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.marineHealthDeclaration")}
                        value={`${this.state.generalDeclarationData!.marineHealthDeclaration}`}
                        type="box"
                        testId="marine-health-declaration"
                        className="big-width"
                    />
                    <SimpleInfoElement
                        label={i18n.t("documents.generalDeclaration.details.general.properties.remarks")}
                        value={`${this.state.generalDeclarationData!.remarks}`}
                        type="box"
                        testId="remarks"
                        className="big-width"
                    />
                </div>
            </div>
        );
    }

    private renderManifests() {
        const properties = ["version", "bookingNo", "arrivalDepartureTime", "loadingType", "cargoDesc", "lorryRegNo", "trailerRegNo", "containerNo"];
        const headers = properties.map(key => i18n.t("documents.generalDeclaration.details.manifests.properties." + key));

        return (
            <div className="section">
                <div className="section-header">
                    {i18n.t("documents.generalDeclaration.details.manifests.header")}
                </div>
                <Table
                    headers={headers}
                    rows={this.state.generalDeclarationData!.manifest?.manifestEntries || []}
                    properties={properties}
                    renderCell={this.renderManifestsListCell.bind(this)}
                    testId="general-declaration-manifests"
                    numberOfElements={this.numberOfElementsForManifests()}
                    currentPage={this.state.currentPage}
                    actions={this.renderManifestActions}
                />
            </div>
        );
    }

    private renderManifestActions(element: ManifestModel) {
        // @ts-ignore
        const elementId = element.id;

        return (
            <>
                {elementId && (
                    <>
                        <NavLink
                            to={`${routingAddresses.documents.manifests.details}/${elementId}`}
                            className="preview-button"
                            data-testid={`preview-${elementId}`}
                        >
                            {i18n.t("documents.manifests.preview")}
                        </NavLink>
                    </>
                )}
            </>
        );
    }

    private renderManifestsListCell(row: any, property: string): JSX.Element {
        if (property === "arrivalDepartureTime") {
            return <>{DateUtils.getFormattedDateWithTime((row[property]))}</>;
        } else if (property === "loadingType") {
            return <>{LoadingTypeFirstLetter[row[property] as LoadingType]}</>;
        }

        return row[property];
    }

    private async getManifestDataForFile(generalDeclarationData: GeneralDeclarationDetailsModel | null | undefined) {
        const manifestId = generalDeclarationData?.manifest?.id;
        const responseForManifestFile = manifestId ? await ManifestService.getManifestDataForFile(manifestId) : undefined;

        this.setState({
            responseForManifestFile,
            manifestDataForFile: Api.isSuccess(responseForManifestFile) ? responseForManifestFile?.data : null
        });
    }

    private async reload() {
        this.setState({generalDeclarationData: undefined});
        const response = this.state.generalDeclarationId ? await GeneralDeclarationService.getGeneralDeclaration(this.state.generalDeclarationId!) : undefined;
        const responseForGeneralDeclarationFile = await GeneralDeclarationService.getGeneralDeclarationDataForFile(this.state.generalDeclarationId!);

        this.setState({
            generalDeclarationData: Api.isSuccess(response) ? response?.data : null,
            response,
            responseForGeneralDeclarationFile,
            generalDeclarationDataForFile: Api.isSuccess(responseForGeneralDeclarationFile) ? responseForGeneralDeclarationFile?.data : null
        });

        this.getManifestDataForFile(this.state.generalDeclarationData);
    }

    private numberOfElementsForManifests() {
        if (this.state.generalDeclarationData!.manifest && this.state.generalDeclarationData!.manifest?.manifestEntries && this.state.generalDeclarationData!.manifest?.manifestEntries.length > 0) {
            return this.state.generalDeclarationData!.manifest?.manifestEntries.length;
        } else return 0;
    }
}

export default withRouter(GeneralDeclarationDetails);
